import styled from 'styled-components';

export const VideoInVideoWrapper = styled.div``;
export const VideoElement = styled.video``;
export const TrackElement = styled.track``;
